export default {
  BATCH_SIZE: 20,
  applicationId: "priorAuth",
  ENROLLMENT_MODAL_SHOWN_KEY: "paperless_enrollment_modal_shown",
};
